var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    strokeWidth: 2.8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3334 30C24.0654 30 30.3334 23.732 30.3334 16C30.3334 8.26801 24.0654 2 16.3334 2C8.60139 2 2.33337 8.26801 2.33337 16C2.33337 23.732 8.60139 30 16.3334 30Z",
    stroke: "#2C67F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1443 10.7724C20.8283 10.5444 21.1703 10.4304 21.3977 10.5115C21.5956 10.582 21.7513 10.7378 21.8219 10.9357C21.903 11.1631 21.789 11.5051 21.561 12.1891L19.4785 18.4367C19.4135 18.6315 19.3811 18.7289 19.3257 18.8098C19.2767 18.8815 19.2148 18.9434 19.1432 18.9924C19.0623 19.0477 18.9649 19.0802 18.7701 19.1451L12.5224 21.2276C11.8385 21.4556 11.4965 21.5696 11.2691 21.4885C11.0711 21.418 10.9154 21.2622 10.8448 21.0643C10.7637 20.8369 10.8777 20.4949 11.1057 19.8109L13.1883 13.5633C13.2532 13.3685 13.2857 13.2711 13.341 13.1902C13.39 13.1185 13.4519 13.0566 13.5236 13.0076C13.6044 12.9523 13.7018 12.9198 13.8966 12.8549L20.1443 10.7724Z",
    stroke: "#2C67F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b8a9ef35b4a76f792a6d1a67b2aabe1f.svg";
export { ForwardRef as ReactComponent };